var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.modal
        ? _c(
            "v-dialog",
            {
              attrs: {
                persistent: "",
                fullscreen: _vm.isMobilePort,
                "max-width": "1200px",
                width: "90%",
                scrollable: "",
              },
              model: {
                value: _vm.modal,
                callback: function ($$v) {
                  _vm.modal = $$v
                },
                expression: "modal",
              },
            },
            [
              _c(
                "v-card",
                {
                  style: {
                    "max-height": _vm.isMobilePort ? "100%" : "95vh",
                    "overflow-y": "auto",
                  },
                },
                [
                  _c(
                    "v-card-title",
                    {
                      staticClass: "primary white--text",
                      class: {
                        headline: !_vm.isMobilePort,
                        "caption mobile-title": _vm.isMobilePort,
                      },
                    },
                    [
                      _vm.isUpdate
                        ? _c("span", [_vm._v("Edit Note / Bookmark")])
                        : _c("span", [_vm._v("Add Note / Bookmark")]),
                      _vm._v(" "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-icon",
                        {
                          staticClass: "primary white--text",
                          on: { click: _vm.closeModal },
                        },
                        [_vm._v("close")]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    { class: _vm.isMobilePort ? "px-3" : "px-4 pt-0 pb-4" },
                    [
                      _vm.isContentLoading
                        ? _c(
                            "v-row",
                            {
                              class: _vm.isMobilePort ? "" : "pt-4",
                              attrs: { dense: "" },
                            },
                            [
                              _c(
                                "v-col",
                                { staticClass: "text-center" },
                                [
                                  _c("v-progress-circular", {
                                    attrs: {
                                      indeterminate: "",
                                      color: "primary",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "mt-2 text-h6 font-weight-medium mb-2",
                                    },
                                    [
                                      _vm._v(
                                        "\n                            Loading section content...\n                        "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _c(
                            "v-row",
                            { attrs: { dense: "" } },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "mb-2",
                                  style: {
                                    "max-height": _vm.isMobilePort
                                      ? "100%"
                                      : "40vh",
                                    "overflow-y": "auto",
                                    "padding-top": "17px",
                                  },
                                },
                                [
                                  _c("default-content-section-controller", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.contentSections.length,
                                        expression: "contentSections.length",
                                      },
                                    ],
                                    attrs: {
                                      highlightType: "insert-into",
                                      contentSections: _vm.contentSections,
                                      registerDialogs: false,
                                      renderToolbar: false,
                                      showTitleAsLink: false,
                                      displayBreadCrumbs: false,
                                      hideContentLinks: true,
                                      displaySectionSeparated: false,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                      _vm._v(" "),
                      _c(
                        "v-row",
                        { attrs: { dense: "" } },
                        [
                          _c("v-col", [
                            _c(
                              "div",
                              {
                                staticClass: "highlight-text",
                                style: {
                                  "--blockquote-border-color": _vm
                                    .selectedTagObj?.color
                                    ? "#" + _vm.selectedTagObj?.color
                                    : "#eee",
                                },
                              },
                              [
                                _c("vue-editor", {
                                  staticClass: "custom-editor",
                                  attrs: {
                                    "editor-toolbar": _vm.customToolbar,
                                  },
                                  model: {
                                    value: _vm.editorData,
                                    callback: function ($$v) {
                                      _vm.editorData = $$v
                                    },
                                    expression: "editorData",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.loadingTags
                        ? _c(
                            "div",
                            {
                              staticClass: "d-flex align-center mt-3",
                              staticStyle: { gap: "8px" },
                            },
                            [
                              _c("v-autocomplete", {
                                ref: "projectTag",
                                staticStyle: { "max-width": "480px" },
                                attrs: {
                                  items: _vm.tags,
                                  "item-text": "tag",
                                  "item-value": "id",
                                  chips: "",
                                  "small-chips": "",
                                  outlined: "",
                                  dense: "",
                                  label: "Project Tag",
                                  rules: [
                                    (v) => !!v || "Project tag is required",
                                  ],
                                  "hide-details": "auto",
                                },
                                on: { change: _vm.updateSelectedTag },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "selection",
                                      fn: function (data) {
                                        return [
                                          _c(
                                            "v-chip",
                                            {
                                              key: _vm.selectedTagObj?.id,
                                              style: {
                                                backgroundColor:
                                                  "#" +
                                                  _vm.selectedTagObj?.color,
                                                color: "#000",
                                              },
                                              attrs: { small: "", close: "" },
                                              on: {
                                                "click:close":
                                                  _vm.removeSelectedTag,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                " +
                                                  _vm._s(data.item.tag) +
                                                  "\n                            "
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2074188780
                                ),
                                model: {
                                  value: _vm.selectedTag,
                                  callback: function ($$v) {
                                    _vm.selectedTag = $$v
                                  },
                                  expression: "selectedTag",
                                },
                              }),
                              _vm._v(" "),
                              _vm.selectedTag !== 1
                                ? _c(
                                    "v-btn",
                                    {
                                      class: _vm.isMobilePort ? "pa-0" : "",
                                      attrs: { outlined: "" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.createNewTagModal(
                                            true,
                                            _vm.selectedTag
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                        Edit Tag\n                    "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  class: _vm.isMobilePort ? "pa-0" : "",
                                  attrs: { outlined: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.createNewTagModal(
                                        false,
                                        _vm.selectedTag
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                        Add Tag\n                    "
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : [
                            _c(
                              "v-row",
                              [
                                _c(
                                  "v-col",
                                  [
                                    _c("v-progress-linear", {
                                      attrs: { indeterminate: true },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                      _vm._v(" "),
                      _vm.activeEnterpriseProfile
                        ? _c(
                            "div",
                            { staticClass: "d-flex align-center mt-3" },
                            [
                              _c("v-select", {
                                staticStyle: { "max-width": "480px" },
                                attrs: {
                                  items: _vm.visibilityItems,
                                  label: "Visibility",
                                  outlined: "",
                                  flat: "",
                                  "hide-details": "",
                                  dense: "",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "selection",
                                      fn: function ({ item }) {
                                        return [
                                          _c(
                                            "v-icon",
                                            { staticClass: "mr-2" },
                                            [_vm._v(_vm._s(item.icon))]
                                          ),
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(item.text) +
                                              "\n                            "
                                          ),
                                        ]
                                      },
                                    },
                                    {
                                      key: "item",
                                      fn: function ({ item }) {
                                        return [
                                          _c(
                                            "v-icon",
                                            { staticClass: "mr-2" },
                                            [_vm._v(_vm._s(item.icon))]
                                          ),
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(item.text) +
                                              "\n                            "
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3449852572
                                ),
                                model: {
                                  value: _vm.selectedVisibility,
                                  callback: function ($$v) {
                                    _vm.selectedVisibility = $$v
                                  },
                                  expression: "selectedVisibility",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        { attrs: { text: "" }, on: { click: _vm.closeModal } },
                        [_vm._v("Cancel")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "primary",
                            disabled: _vm.isContentLoading,
                            loading: _vm.isSaving,
                          },
                          on: { click: _vm.saveNote },
                        },
                        [_vm._v("Save")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }